import React, { useState } from "react";
import { X } from "lucide-react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/CallbackRequestPopup.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_URL from "./../../common/config";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { Country } from "country-state-city";
import ElegantPopup1 from "../../common/Popup";

const CallbackRequestPopup = ({ isOpen, onClose }) => {
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();
  const countries = Country.getAllCountries();
  const [formData, setFormData] = useState({
    fullName: "",
    // mobileNumber: "",
    companyName: "",
    companyEmail: "",
    designation: "",
    country: "",
  });
  const getCountryCode = () => {
    if (!formData.country) return undefined;

    // PhoneInput expects ISO 3166-1 alpha-2 codes in lowercase
    return formData.country.toLowerCase();
  };

  const handleClose = async () => {
    setShowPopup(false);
    window.location.reload();
  };

  const handlePhoneChange = (value) => {
    setFormData((prev) => ({ ...prev, mobileNumber: value }));
    // const fieldErrors = ("phone_no", value);
    // setFormErrors((prev) => ({
    //   ...prev,
    //   phone_no: fieldErrors.phone_no || "", // Clear error if valid
    //   ...(fieldErrors.phone_no ? fieldErrors : {}),
    // }));

    // if (Object.keys(fieldErrors).length > 0 && fieldErrors.phone_no) {
    //   focusOnFirstError(fieldErrors, inputRefs);
    // }
  };

  const handleCountryChange = (e) => {
    const countryCode = e.target.value;
    const country = countries.find((c) => c.isoCode === countryCode);
    setFormData((prev) => ({
      ...prev,
      country: countryCode,
      mobileNumber: `+${country?.phonecode || ""}`, // Keep phone code as is
    }));

    // const fieldErrors = validateField("country", countryCode);
    // setFormErrors((prev) => ({
    //   ...prev,
    //   country: fieldErrors.country || "", // Clear error if valid
    //   ...(fieldErrors.country ? fieldErrors : {}),
    // }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        `${API_URL}/api/request/callback`,
        formData
      );

      if (response.status === 201) {
        console.log("Form submitted successfully, email sent");
        setFormData({
          fullName: "",
          mobileNumber: "",
          companyName: "",
          companyEmail: "",
          designation: "",
          country: "",
        });

        // Redirect to Thank You page
        // navigate("/thank-you");
        setShowPopup(true);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="callback-popup-overlay">
      <div className="callback-popup-container">
        <div className="callback-popup-header">
          <h3>Request a Callback</h3>
          <button className="close-button" onClick={onClose}>
            <X size={24} color="#fff" />
          </button>
        </div>

        <div className="callback-popup-body">
          <p>Please fill in your details and we'll get back to you soon.</p>

          <form onSubmit={handleSubmit}>
            <div className="form-grid">
              <div className="form-group">
                <label htmlFor="fullName">Full Name*</label>
                <input
                  type="text"
                  className="form-control"
                  id="fullName"
                  name="fullName"
                  placeholder="Enter your full name"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* <div className="form-group">
                <label htmlFor="mobileNumber">Mobile Number*</label>
                <input
                  type="tel"
                  className="form-control"
                  id="mobileNumber"
                  name="mobileNumber"
                  placeholder="Enter your mobile number"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  required
                />
              </div> */}

              <div className="form-group">
                <label htmlFor="companyName">Company Name*</label>
                <input
                  type="text"
                  className="form-control"
                  id="companyName"
                  name="companyName"
                  placeholder="Enter your company name"
                  value={formData.companyName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="companyEmail">Company Email*</label>
                <input
                  type="email"
                  className="form-control"
                  id="companyEmail"
                  name="companyEmail"
                  placeholder="Enter your company email"
                  value={formData.companyEmail}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="designation">Designation*</label>
                <input
                  type="text"
                  className="form-control"
                  id="designation"
                  name="designation"
                  placeholder="Enter your designation"
                  value={formData.designation}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label className="small-label">Tell us your country! *</label>
                <select
                  // ref={inputRefs.country}
                  name="country"
                  value={formData.country || ""}
                  onChange={handleCountryChange}
                  className="form-control"
                  required
                >
                  <option value="" hidden>
                    Select Country
                  </option>
                  {countries.map((country) => (
                    <option key={country.isoCode} value={country.isoCode}>
                      {country.name}
                    </option>
                  ))}
                </select>
                {/* {formErrors.country && (
                    <p className="text-red">{formErrors.country}</p>
                  )} */}
              </div>
              {/* </div> */}
              {/* <div className="col-lg-4"> */}
              <div className="form-group">
                <label className="small-label">Mobile No.*</label>
                <PhoneInput
                  // ref={inputRefs.phone_no}
                  value={formData.mobileNumber || ""}
                  name="mobileNumber"
                  onChange={handlePhoneChange}
                  className="form-control"
                  required
                  flags={countries.flag}
                  country={getCountryCode()}
                  countryCallingCodeEditable={false}
                  countrySelectProps={{
                    disabled: false,
                    className: "country-select-disabled",
                  }}
                />
                {/* {formErrors.phone_no && (
                    <p className="text-red">{formErrors.phone_no}</p>
                  )} */}
              </div>
              {/* </div> */}

              <div className="form-buttons">
                <button
                  type="button"
                  className="cancel-button"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="submit-button btn-primary try-free-btn"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <style jsx>{`
        .country-select-disabled {
          pointer-events: none;
          opacity: 0;
        }
      `}</style>
      {showPopup && (
        <div className="popup-overlay">
          <ElegantPopup1
            handlePopUpClose={() => handleClose()}
            message="Thank you for your feedback"
          />
        </div>
      )}
    </div>
  );
};

export default CallbackRequestPopup;
